import { cx } from '@linaria/core';
import { PostloadedImage } from '@utils/react';
import { list, bullet, button } from './atom.bullets.style.js';
import { jsx, jsxs } from 'react/jsx-runtime';

function Bullets(props) {
  return /*#__PURE__*/jsx("ul", {
    className: list,
    "data-type": props.bulletType,
    children: props.slides.map((slide, index) => /*#__PURE__*/jsx("li", {
      children: /*#__PURE__*/jsx("button", {
        className: cx(button, props.activeIndex === index && "active"),
        onClick: () => props.onBulletClick(index),
        "aria-label": `Gå til slide ${index + 1}`,
        "data-type": props.bulletType,
        children: /*#__PURE__*/jsx("span", {
          className: cx(bullet, props.activeIndex === index && "active"),
          "data-type": props.bulletType,
          children: /*#__PURE__*/jsxs("span", {
            children: [props.bulletType === "numbered" ? index + 1 : undefined, props.bulletType === "thumb" && /*#__PURE__*/jsx(PostloadedImage, {
              alt: "",
              src: slide.image.src,
              width: slide.image.width,
              height: slide.image.height,
              sizes: "150px"
            })]
          })
        })
      })
    }, index))
  });
}

export { Bullets };
//# sourceMappingURL=atom.bullets.js.map
